<style lang="less" scoped>
/deep/.ivu-input-wrapper {
  display: flex;
}

/deep/.ivu-input {
  display: block;
  height: 30px;
  width: 100%;
  line-height: 30px; // border-radius: 18px;
  margin: 8px 10px;
  display: inline-block;
  outline: none; // border: 1px solid #ececec;
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;
  font-size: 12px;
  color: #454545;
}

/deep/.ivu-input-icon {
  right: 10px !important;
  top: 7px !important;
  font-size: 18px;
}
// }
// ul li {
//   list-style: none;
// }
.main {
  margin-top: 35px;
  .selects {
    height: 33px;
    line-height: 33px;
    background: #fff;
    padding-top: 45px !important;
    justify-content: space-evenly;
    ul {
      display: flex;
      background: #fff;
      justify-content: space-around;
      li {
        font-family: PingFangSC-Regular;
        font-size: 11px;
        color: #333333;
        img {
          margin-left: 3px;
          width: 10px;
          vertical-align: middle;
        }
      }
    }
  }
  .search {
    background: #fff;
    position: fixed;
    width: 100%;
    z-index: 200;
    padding-top: 3px;
    padding-bottom: 3px;
  }

  .lists {
    margin: 5px;
    border-radius: 5px;
  }
}

.active {
  color: #064a7b !important;
  font-weight: 550;
}
</style>
<template>
  <div>
    <Header ref="header"></Header>
    <div class="content">
      <div class="main">
        <!-- <div class="search"> -->
        <div class="search">
          <Input
            type="text"
            :placeholder="$t('main.content28')"
            v-model="container"
            search
            @keyup.enter.native="searchs"
            @on-search="searchs"
          />
        </div>
        <!-- <div style="display: flex">
            <Input
              type="text"
              :placeholder="$t('main.content28')"
              v-model="container"
              search
              @keyup.enter.native="searchs"
              @on-search="searchs"
            />
        
          </div> -->
        <!-- </div> -->

        <div class="lists">
          <div v-show="showPaper">
            <comPaper ref="comPaper"></comPaper>
          </div>
          <div v-show="showPriprent">
            <priprent ref="priprent"></priprent>
          </div>
          <div v-show="showDiss">
            <dissertation ref="dissertation"></dissertation>
          </div>
        </div>
      </div>
    </div>
    <ComFooter></ComFooter>
  </div>
</template>
<script>
import ComFooter from "@/components/footer.vue";
import Header from "@/components/comHeader.vue";
import comPaper from "@/components/paper.vue";
import priprent from "@/components/priList.vue";
import dissertation from "@/components/dissertation.vue";
// import { Loadmore } from "mint-ui";
import { Indicator } from "mint-ui";
export default {
  components: {
    ComFooter,
    Header,
    comPaper,
    dissertation,
    priprent,
    [Indicator.name]: Indicator,
  },
  data() {
    return {
      topStatus: "",

      allLoaded: false,
      showSearch: true,
      showDiss: false,
      stateList: "",
      activeColor: "#064a7b",
      fontWeight: "bold",
      activeColor1: "",
      fontWeight1: "",
      total: 0,
      cancelSearch: false,
      datas: [],
      container: "",

      showPaper: false,
      showPriprent: false,

      prefix: "",
      url: "",
      title: this.$t("keywords.keywords14"),
    };
  },

  mounted() {
    
    this.stateList = this.$route.query.params;


    if (this.stateList == "paper") {
      this.showPaper = true;
      this.showPriprent = false;
      this.showDiss = false;
      this.$refs.header.title = this.title;
      this.$refs.comPaper.getList(this.pageNumber);
    } else if (this.stateList == "priprent") {
      this.showPaper = false;
      this.showPriprent = true;
      this.showDiss = false;
      this.$refs.header.title = this.$t("header.home27");
      if (this.$getUrlParam("prefix")) {
        this.$refs.priprent.prefix = this.$getUrlParam("prefix");
      }
      this.$refs.priprent.getList(this.pageNumber);
    } else {
      this.showPaper = false;
      this.$refs.dissertation.getDissList();
      this.showPriprent = false;
      this.$refs.header.title = this.$t("header.home33");
      this.showDiss = true;
    }
  },
  methods: {
    async searchs() {
      Indicator.open({
        text: "loading...",
        spinnerType: "fading-circle",
      });
      if (this.stateList == "paper") {
        this.showPaper = true;
        this.showPriprent = false;
        this.showDiss = false;
        this.pageNumber = 1;
        this.$refs.comPaper.container = this.container;
        this.$refs.comPaper.datas = [];
        if (this.container != "") {
          //this.$refs.showPaper.container = this.container
          this.$refs.comPaper.getList(this.pageNumber);
          this.total = this.$refs.comPaper.total;
        } else {
          this.$refs.comPaper.getList(this.pageNumber);
          this.total = this.$refs.priprent.total;
        }
      }
      if (this.stateList == "priprent") {
        this.showPaper = false;
        this.showPriprent = true;
        this.showDiss = false;
        this.pageNumber = 1;
        this.$refs.priprent.datas = [];
        this.$refs.priprent.container = this.container;
        if (this.container != "") {
          //this.$refs.showPaper.container = this.container
          this.$refs.priprent.getList(this.pageNumber);
          this.total = this.$refs.priprent.total;
        } else {
          this.$refs.priprent.getList(this.pageNumber);
          this.total = this.$refs.priprent.total;
        }
      }
      if (this.stateList == "diss") {
        this.showPaper = false;
        this.showPriprent = false;
        this.showDiss = true;
        this.$refs.dissertation.pageNumber = 1;
        this.$refs.dissertation.datas = [];
        this.$refs.dissertation.container = this.container;
        if (this.container != "") {
          //this.$refs.showPaper.container = this.container
          this.$refs.dissertation.getDissList(this.pageNumber);
          this.total = this.$refs.dissertation.total;
        } else {
          this.$refs.dissertation.getDissList(this.pageNumber);
          this.total = this.$refs.dissertation.total;
        }
      }
    },

    leftContent() {
      this.$router.back();
    },
    cancel() {
      Indicator.open({
        text: "loading...",
        spinnerType: "fading-circle",
      });

      this.$refs.priprent.datas = [];
      this.$refs.comPaper.datas = [];
      if (this.stateList == "paper") {
        this.$refs.comPaper.pageNumber = 1;

        this.$refs.comPaper.container = "";

        this.$router.push({ query: {} });

        this.container = "";
        this.$refs.comPaper.getList(this.pageNumber);
      }
      if (this.stateList == "priprent") {
        this.$refs.priprent.pageNumber = 1;
        this.$refs.priprent.container = "";

        this.$router.push({ query: {} });

        this.container = "";
        this.$refs.priprent.getList(this.pageNumber);
      }
    },
  },
};
</script>